import { initDestMapHero } from '../lib/dest-map-hero.js';

function initNavScroll() {
  const nav = document.getElementById('dest-nav');
  if (!nav) return;
  const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 30);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

function init() {
  initNavScroll();
  initDestMapHero();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
